import { useInfiniteQuery } from '@tanstack/react-query';
import { getUserService } from '@src/container';
import type { SearchParams } from '@src/domain/users/repository/user.repository.interface';

export interface UseSearchUsersParams extends SearchParams {
    limit?: number;
    query?: string; // general search query
}

export const useSearchUsersPaginated = (params: UseSearchUsersParams = {}) => {
    const userService = getUserService();

    return useInfiniteQuery({
        queryKey: ['users', 'search', params],
        queryFn: async ({ pageParam = 0 }) => {
            return userService.search({
                name: params.query,
                email: params.query,
                phone: params.query,
                skip: pageParam,
                limit: params.limit || 50,
            });
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.hasMore) {
                return (lastPage.page - 1) * lastPage.page_size + lastPage.page_size;
            }
            return undefined;
        },
        initialPageParam: 0,
    });
};